import styled from 'styled-components';
import { Typography, Stack } from '@mui/material';
import { ReactComponent as EmptyGraphic } from '../../assets/sleepy-cloud.svg';
import { FlexColumn } from '../Flex';
import { fontSize, fontWeight, space } from '../../style/utils';

const Wrapper = styled(FlexColumn)`
  align-items: center;
  gap: ${space('xs')};
`;

const Message = styled(Typography).attrs(() => ({
  component: 'span',
}))`
  white-space: pre-wrap;
  text-align: center;
  color: ${({ theme }) => theme.palette.content.secondary};
  font-size: ${fontSize('lg')};
`;

const EmptyStateBoxLink = styled.a`
  color: ${({ theme }) => theme.palette.accent.primary};
`;

const EmptyStateBoxSubTitle = styled(Message)`
  text-decoration: underline;
`;

const EmptyStateBoxClickableText = styled(Message)`
  color: ${({ theme }) => theme.palette.accent.primary};
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  title: string;
  children: React.ReactNode;
  graphic?: React.ReactNode;
};

const EmptyStateBox = ({
  title,
  children,
  graphic = <EmptyGraphic />,
}: Props) => (
  <Wrapper>
    <Stack sx={{ mb: '16px' }}>{graphic}</Stack>

    <Typography
      sx={{ fontSize: fontSize('lg'), fontWeight: fontWeight('semibold') }}
    >
      {title}
    </Typography>

    <Message>{children}</Message>
  </Wrapper>
);

EmptyStateBox.Link = EmptyStateBoxLink;
EmptyStateBox.SubTitle = EmptyStateBoxSubTitle;
EmptyStateBox.ClickableText = EmptyStateBoxClickableText;

export default EmptyStateBox;
